// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import { jsx } from 'panel';
import { ModalEl } from 'common/components/modal';
import { ButtonEl } from 'common/components/button';
import { ButtonSize, ButtonTheme } from 'common/components/button/constants';

/*
  We show this modal to enterprise customers who visit the plan builder
  in order to prevent them from interacting with the plan builder and 
  guide them to our contact sales page.
*/

export const EnterpriseModal = (isOpen, trackContactSalesClicked, isStartup, orgId) => {
  const planDetailUrl = orgId ? "/settings/org/" + orgId + "/plan" : "/";
  const ctaUrl = isStartup ? planDetailUrl : "/pricing";
  return <ModalEl attrs={{
    open: isOpen,
    closeable: false
  }} sel='.modal-wrapper' data-sentry-element="ModalEl" data-sentry-component="EnterpriseModal" data-sentry-source-file="enterprise-modal.tsx">
      <div sel='.modal-content'>
        <div sel='.modal-title'>Contact sales to edit your {isStartup ? "Startup" : "Enterprise"} plan</div>
        <div sel='.modal-body'>
          {isStartup ? "You are currently enrolled in the Mixpanel for Startups program. To make changes to your Startup Plan, please get in touch with our team for assistance." : "We've found that Enterprise plans often require customization for your needs, and are better served with a\n          human touch. Get in touch to renew or edit your Enterprise plan."}
        </div>
        <div sel='.buttons'>
          <ButtonEl attrs={{
          theme: ButtonTheme.MarketingSecondary,
          href: ctaUrl,
          size: ButtonSize.Large
        }} data-sentry-element="ButtonEl" data-sentry-source-file="enterprise-modal.tsx">
            {isStartup ? "See Usage" : "View Pricing"}
          </ButtonEl>
          <ButtonEl attrs={{
          theme: ButtonTheme.MarketingPrimary,
          href: "/contact-us/sales",
          size: ButtonSize.Large
        }} on={{
          click: trackContactSalesClicked
        }} data-sentry-element="ButtonEl" data-sentry-source-file="enterprise-modal.tsx">
            Contact Sales
          </ButtonEl>
        </div>
      </div>
    </ModalEl>;
};